import React from 'react';

const DateRangeFilter = ({ dateRange, onChange }) => {
  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    
    // Ensure start date is not after end date
    const endDate = dateRange.endDate;
    if (newStartDate > endDate) {
      onChange({
        startDate: newStartDate,
        endDate: newStartDate
      });
    } else {
      onChange({
        ...dateRange,
        startDate: newStartDate
      });
    }
  };
  
  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    
    // Ensure end date is not before start date
    const startDate = dateRange.startDate;
    if (newEndDate < startDate) {
      onChange({
        startDate: newEndDate,
        endDate: newEndDate
      });
    } else {
      onChange({
        ...dateRange,
        endDate: newEndDate
      });
    }
  };
  
  // Predefined date range options
  const datePresets = [
    { label: 'Next 30 days', days: 30 },
    { label: 'Next 90 days', days: 90 },
    { label: 'Next 6 months', days: 180 },
    { label: 'Max (332 days)', days: 331 }
  ];
  
  const handlePresetChange = (days) => {
    const startDate = new Date().toISOString().split('T')[0]; // Today
    
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + days);
    
    onChange({
      startDate,
      endDate: endDate.toISOString().split('T')[0]
    });
  };
  
  const daysBetween = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };
  
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label 
            htmlFor="startDate" 
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Start Date
          </label>
          <input
            type="date"
            id="startDate"
            value={dateRange.startDate || ''}
            onChange={handleStartDateChange}
            min={new Date().toISOString().split('T')[0]} // Min date is today
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
        
        <div>
          <label 
            htmlFor="endDate" 
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            End Date
          </label>
          <input
            type="date"
            id="endDate"
            value={dateRange.endDate || ''}
            onChange={handleEndDateChange}
            min={dateRange.startDate || new Date().toISOString().split('T')[0]}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Quick Select
        </label>
        <div className="flex flex-wrap gap-2">
          {datePresets.map((preset) => (
            <button
              key={preset.days}
              type="button"
              onClick={() => handlePresetChange(preset.days)}
              className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {preset.label}
            </button>
          ))}
        </div>
      </div>
      
      <div className="pt-2">
        <div className="bg-blue-100 text-blue-800 p-2 rounded-md text-center">
          Showing {daysBetween(dateRange.startDate, dateRange.endDate) + 1} days of data
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;